import { ReactElement } from 'react';

import { useTheme, Typography } from '@mui/material';

import { useElementSize } from 'usehooks-ts';

import { GameModalProps } from './types';

import Center from '../../../../../../../../components/Center';
import Modal from '../../../../../../../../components/Modal';
import ModalHeader from '../../../../../../../../components/Modal/components/Header';

export default function GameModal(props: GameModalProps): ReactElement {
  const theme = useTheme();

  const [headerRef, { height: headerHeight }] = useElementSize();

  const { open, children, title, onClose, ...rest } = props;

  return (
    <Modal
      {...rest}
      fullScreen
      onClose={() => onClose()}
      open={open}
      sx={{ '& .MuiPaper-root': { backgroundColor: theme.palette.common.black } }}>
      <Center ref={headerRef}>
        <ModalHeader
          renderTitle={(props) => (
            <Typography {...props} color='grey.50'>
              {title}
            </Typography>
          )}
          sx={{ backgroundColor: 'transparent' }}
        />
      </Center>
      <Center width='100%' height={`calc(100vh - ${headerHeight}px)`}>
        {children}
      </Center>
    </Modal>
  );
}
